import React from 'react';
import { motion } from 'framer-motion';
import { Video, Send } from 'lucide-react';
export function MechanismReveal() {
  return <section className="w-full bg-[#0F1B2D] text-[#FAFAF5] py-24 px-6 md:px-12" data-id="element-119">
      <div className="max-w-6xl mx-auto" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-121">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-122">
            Introducing: <span className="text-[#E8722A]" data-id="element-123">UGC Starter Kit</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-124">
            Get Your First Paid Brand Video in 7 Days (Even With 0 Followers)
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-125">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#162438] border border-gray-700 rounded-2xl p-8 hover:border-[#E8722A] transition-colors group" data-id="element-126">
            <div className="w-12 h-12 bg-[#E8722A]/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#E8722A]/20 transition-colors" data-id="element-127">
              <Video className="w-6 h-6 text-[#E8722A]" data-id="element-128" />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-129">
              Part 1: The 4-Video Proof Stack
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4" data-id="element-130">
              You'll create 4 "spec" videos (with products you already have)
              that instantly answer a brand's silent question:
            </p>
            <blockquote className="border-l-4 border-[#E8722A] pl-4 italic text-white mb-4" data-id="element-131">
              "Can this person deliver?"
            </blockquote>
            <p className="text-gray-400 text-sm" data-id="element-132">
              You're not making random content. You're building a small
              portfolio that looks like you've done this before.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-[#162438] border border-gray-700 rounded-2xl p-8 hover:border-[#E8722A] transition-colors group" data-id="element-133">
            <div className="w-12 h-12 bg-[#E8722A]/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#E8722A]/20 transition-colors" data-id="element-134">
              <Send className="w-6 h-6 text-[#E8722A]" data-id="element-135" />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-136">
              Part 2: The 30-Pitch Sprint
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4" data-id="element-137">
              Then you run the outreach loop that most beginners avoid because
              it's uncomfortable:
            </p>
            <ul className="space-y-2 mb-4 text-white" data-id="element-138">
              <li className="flex items-center gap-2" data-id="element-139">
                <span className="w-1.5 h-1.5 bg-[#E8722A] rounded-full" data-id="element-140" /> one
                pitch per day
              </li>
              <li className="flex items-center gap-2" data-id="element-141">
                <span className="w-1.5 h-1.5 bg-[#E8722A] rounded-full" data-id="element-142" /> a
                tracking sheet (so you don't spiral)
              </li>
              <li className="flex items-center gap-2" data-id="element-143">
                <span className="w-1.5 h-1.5 bg-[#E8722A] rounded-full" data-id="element-144" />{' '}
                follow-up rules (so you don't get ignored)
              </li>
            </ul>
            <p className="text-gray-400 text-sm" data-id="element-145">Not sexy. Just effective.</p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center mt-12" data-id="element-146">
          <p className="text-lg font-medium text-gray-400 uppercase tracking-widest" data-id="element-147">
            Not sexy. Just effective.
          </p>
        </motion.div>
      </div>
    </section>;
}